var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Utils from '@datocms/rest-client-utils';
import BaseResource from '../../BaseResource';
var EditingSession = /** @class */ (function (_super) {
    __extends(EditingSession, _super);
    function EditingSession() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * List all editing sessions
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/editing-session/instances
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     *
     * @deprecated This API call is to be considered private and might change without notice
     */
    EditingSession.prototype.list = function () {
        return this.rawList().then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * List all editing sessions
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/editing-session/instances
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     *
     * @deprecated This API call is to be considered private and might change without notice
     */
    EditingSession.prototype.rawList = function () {
        return this.client.request({
            method: 'GET',
            url: '/editing-sessions',
        });
    };
    /**
     * Allows all actions on editing sessions
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/editing-session/update
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     *
     * @deprecated This API call is to be considered private and might change without notice
     */
    EditingSession.prototype.rawUpdate = function (editingSessionId, body) {
        return this.client.request({
            method: 'PUT',
            url: "/editing-sessions/".concat(editingSessionId),
            body: body,
        });
    };
    /**
     * Delete an editing session
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/editing-session/destroy
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     *
     * @deprecated This API call is to be considered private and might change without notice
     */
    EditingSession.prototype.destroy = function (editingSessionId) {
        return this.rawDestroy(Utils.toId(editingSessionId)).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Delete an editing session
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/editing-session/destroy
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     *
     * @deprecated This API call is to be considered private and might change without notice
     */
    EditingSession.prototype.rawDestroy = function (editingSessionId) {
        return this.client.request({
            method: 'DELETE',
            url: "/editing-sessions/".concat(editingSessionId),
        });
    };
    EditingSession.TYPE = 'editing_session';
    return EditingSession;
}(BaseResource));
export default EditingSession;
//# sourceMappingURL=EditingSession.js.map